// CropDoctor i18n strings — keep keys flat for simplicity
// Add a new language by extending each map.

export const TRANSLATIONS = {
  en: {
    "common.login": "Login",
    "common.signup": "Sign up",
    "common.logout": "Logout",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.save": "Save",
    "common.back": "Back",
    "common.loading": "Loading…",
    "common.confirm": "Confirm",
    "common.required": "Required",
    "common.optional": "(optional)",

    "nav.home": "Home",
    "nav.history": "History",
    "nav.fields": "Fields",
    "nav.profile": "Profile",

    "landing.tagline": "AI-powered crop diagnosis in 12 seconds",
    "landing.h1.line1": "Snap a leaf.",
    "landing.h1.line2": "Save your harvest.",
    "landing.subtitle": "Upload a photo of your crop and get an instant disease diagnosis with organic and chemical treatment advice — in your language.",
    "landing.cta.scan": "Scan my crop",
    "landing.cta.haveAccount": "I already have an account",
    "landing.trusted": "Trusted by farmers",
    "landing.languages": "5 languages",
    "landing.howH2": "How Hansa helps",
    "landing.howSub": "From the field to your phone — expert guidance, always ready.",
    "landing.feat.diag.title": "Instant diagnosis",
    "landing.feat.diag.body": "Snap a leaf photo; AI identifies the disease with confidence score, symptoms and causes.",
    "landing.feat.treat.title": "Organic + Chemical",
    "landing.feat.treat.body": "Get both natural remedies and proven chemical treatments with clear dosage hints.",
    "landing.feat.weather.title": "Weather-smart tips",
    "landing.feat.weather.body": "Live weather data plus LLM-powered farming advice for the next 3 days.",
    "landing.feat.lang.title": "5 languages",
    "landing.feat.lang.body": "English, हिन्दी, मराठी, தமிழ், తెలుగు — choose your comfort language.",
    "landing.feat.history.title": "Scan history",
    "landing.feat.history.body": "All your scans saved so you can track crop health over time.",
    "landing.feat.models.title": "Multi-model AI",
    "landing.feat.models.body": "Smart Auto router picks Gemini 3 Flash, GPT-5.2 or Claude Sonnet 4.5 per scan.",
    "landing.feat.medCheck.title": "Medicine / chemical check",
    "landing.feat.medCheck.body": "Photograph any pesticide bottle and AI tells you if it's right for your crop, the correct dosage, and safety warnings.",

    "landing.medCheck.tagline": "NEW · UNIQUE TO HANSA",
    "landing.medCheck.h2.line1": "Don't waste money on",
    "landing.medCheck.h2.line2": "the wrong medicine",
    "landing.medCheck.body": "Just photograph the bottle or label. Hansa reads the active ingredient and tells you if it's safe for your crop, the right dosage per litre, when to spray, safety gear and any harsh-chemical warnings — all in your language.",
    "landing.medCheck.b1": "Verify the chemical is right for your crop and disease",
    "landing.medCheck.b2": "Get exact dosage per litre and per acre",
    "landing.medCheck.b3": "Safety warnings, PPE and re-entry interval",
    "landing.medCheck.b4": "Suggests organic alternatives if available",
    "landing.medCheck.cta": "Try medicine check",
    "landing.medCheck.cardLabel": "Medicine check result",
    "landing.medCheck.cardSafe": "Safe to use for Tomato · Late Blight",
    "landing.medCheck.cardWarn": "Wear gloves & mask. Avoid pre-harvest spraying.",

    "auth.welcomeBack": "Welcome back",
    "auth.welcomeBack.sub": "Login to scan and manage your crops.",
    "auth.startFree": "Start for free",
    "auth.startFree.sub": "Create an account to diagnose and track your crops.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.fullName": "Full name",
    "auth.location": "Location",
    "auth.signingIn": "Signing in…",
    "auth.creating": "Creating…",
    "auth.create": "Create account",
    "auth.newHere": "New here?",
    "auth.haveAccount": "Already have an account?",
    "auth.useMobile": "Login with mobile OTP",
    "auth.useEmail": "Login with email & password",
    "auth.phone": "Mobile number",
    "auth.phonePlaceholder": "+91 98XXXXXXXX",
    "auth.sendOtp": "Send OTP",
    "auth.sendingOtp": "Sending…",
    "auth.otp": "OTP code",
    "auth.otpPlaceholder": "6-digit code",
    "auth.verifyOtp": "Verify & Continue",
    "auth.verifying": "Verifying…",
    "auth.otpSent": "OTP sent. Check your SMS.",
    "auth.changePhone": "Change number",
    "auth.firstTimeName": "Your name (first time only)",

    "dash.greet": "Hi {name} 👋",
    "dash.subtitle": "Let's diagnose your crop.",
    "dash.scanCrop": "Scan your crop",
    "dash.scanCrop.sub": "Take a photo or upload a clear image of the affected leaf or plant",
    "dash.useCamera": "Use Camera",
    "dash.uploadPhoto": "Upload Photo",
    "dash.cropHint": "What crop is this?",
    "dash.cropHint.placeholder": "e.g., Tomato, Wheat, Rice...",
    "dash.aiModel": "AI model",
    "dash.language": "Language",
    "dash.field": "Field / Plot",
    "dash.field.none": "No field (one-off scan)",
    "dash.diagnose": "Diagnose now",
    "dash.diagnosing": "Diagnosing…",
    "dash.saveOffline": "Save offline",
    "dash.weather": "Today's Weather",
    "dash.weatherLoading": "Loading weather…",
    "dash.weatherUnavail": "Weather unavailable",
    "dash.recentScans": "Recent scans",
    "dash.viewAll": "View all",
    "dash.noScans": "No scans yet. Try your first!",
    "dash.offlineBanner": "You're offline. Scans will be queued.",
    "dash.queuedPending": "{n} queued scan pending",
    "dash.queuedPendingPlural": "{n} queued scans pending",
    "dash.syncing": "Syncing {n} queued scan…",
    "dash.syncingPlural": "Syncing {n} queued scans…",
    "dash.syncNow": "Sync now",
    "dash.listening": "Listening… speak the crop name",
    "dash.voiceCaptured": "Voice captured",
    "dash.uploadFirst": "Please upload a crop photo first",
    "dash.diagnosisReady": "Diagnosis ready",
    "dash.savedOffline": "Saved offline. We'll upload when you're back online.",
    "dash.networkIssue": "Network issue — saved offline, will retry.",

    "scan.pdf": "PDF",
    "scan.askAi": "Ask AI",
    "scan.delete": "Delete",
    "scan.deleteTitle": "Delete this scan?",
    "scan.deleteDesc": "This action cannot be undone. The diagnosis and image will be permanently removed from your history.",
    "scan.pdfExported": "PDF exported",
    "scan.pdfFailed": "PDF export failed",
    "scan.deleted": "Scan deleted",
    "scan.deleteFailed": "Delete failed",
    "scan.notFound": "Scan not found",
    "scan.deleting": "Deleting…",

    "diag.notPlant": "No plant detected",
    "diag.healthy": "Healthy plant",
    "diag.unknown": "Unknown issue",
    "diag.crop": "Crop",
    "diag.confidence": "Confidence",
    "diag.symptoms": "Symptoms observed",
    "diag.causes": "Likely causes",
    "diag.organic": "Organic remedies",
    "diag.chemical": "Chemical treatment",
    "diag.prevention": "Prevention tips",
    "diag.greatNews": "Great news",
    "diag.greatNewsBody": "Your plant appears healthy. Continue regular care and monitoring.",
    "diag.prePlant.title": "Before-planting guide",
    "diag.prePlant.season": "Best season",
    "diag.prePlant.soil": "Soil preparation",
    "diag.prePlant.spacing": "Spacing",
    "diag.prePlant.fertilizer": "Fertilizer",
    "diag.prePlant.seed": "Seed selection",
    "diag.prePlant.timeline": "Crop timeline",
    "diag.prePlant.yield": "Expected yield",
    "diag.growth.title": "Growth check",
    "diag.growth.stage": "Growth stage",
    "diag.growth.advice": "Care tips for this stage",
    "diag.buy": "Buy",

    "history.title": "Scan history",
    "history.sub": "All your past crop diagnoses.",
    "history.empty": "No scans yet",
    "history.emptySub": "Scan your first crop to build your history.",
    "history.scanNow": "Scan now",
    "history.confident": "{c}% confident",

    "fields.title": "My fields",
    "fields.sub": "Track named plots and growth over time.",
    "fields.empty": "No fields yet",
    "fields.emptySub": "Create a field to track scans across the crop's lifecycle.",
    "fields.new": "New field",
    "fields.create": "Create field",
    "fields.creating": "Creating…",
    "fields.name": "Field name",
    "fields.name.placeholder": "e.g., Tomato Plot A",
    "fields.crop": "Crop",
    "fields.crop.placeholder": "e.g., Tomato",
    "fields.plantedOn": "Planted on",
    "fields.scanCount": "{n} scan",
    "fields.scanCountPlural": "{n} scans",
    "fields.lastScan": "Last scan: {date}",
    "fields.openTimeline": "Open timeline",
    "fields.timeline": "Growth timeline",
    "fields.noTimelineScans": "No scans yet for this field. Upload one from the dashboard with this field selected.",
    "fields.deleteTitle": "Delete this field?",
    "fields.deleteDesc": "Scans linked to this field will be kept but un-linked. This cannot be undone.",
    "fields.deleted": "Field deleted",

    "profile.title": "Profile",
    "profile.member": "Hansa member",
    "profile.joined": "Joined",

    "chat.title": "AI Agronomist",

    "chem.title": "Verify Chemical / Medicine",
    "chem.subtitle": "Photograph the bottle or label — AI will tell you if it's right for your crop and the correct dosage.",
    "chem.linkedScan": "Linked to your recent scan",
    "chem.useCamera": "Use Camera",
    "chem.uploadPhoto": "Upload Photo",
    "chem.crop": "Crop",
    "chem.crop.placeholder": "e.g., Tomato, Wheat",
    "chem.disease": "Disease / Problem",
    "chem.disease.placeholder": "e.g., Late blight, Aphids",
    "chem.verify": "Verify medicine",
    "chem.verifying": "Reading label…",
    "chem.uploadFirst": "Please add a label photo first",
    "chem.tooLarge": "Image too large. Use a smaller photo.",
    "chem.failed": "Verification failed. Try again.",
    "chem.done": "Verification ready",
    "chem.unreadable": "Label not readable",
    "chem.verdict.safe": "Safe to use",
    "chem.verdict.unsafe": "Not recommended",
    "chem.verdict.unclear": "Use with caution",
    "chem.dosage": "Dosage",
    "chem.spray": "Spray timing",
    "chem.phi": "Pre-harvest interval",
    "chem.rei": "Re-entry interval",
    "chem.ppe": "Safety gear (PPE)",
    "chem.warnings": "Safety warnings",
    "chem.alternatives": "Organic alternatives",
    "dash.verifyMedicine": "Verify medicine / chemical",
    "dash.verifyMedicineSub": "Scan a bottle or label — get safety + dosage advice",
    "dash.soilReport": "Satellite soil report",
    "dash.soilReportSub": "Free pH, organic matter & fertilizer advice for your field",
    "scan.verifyMedicine": "Verify medicine",

    "soil.title": "Soil report",
    "soil.subtitle": "Free satellite-derived soil data for your field, plus AI-powered fertilizer & irrigation advice.",
    "soil.location": "Field location",
    "soil.location.none": "Tap relocate to share your GPS",
    "soil.relocate": "Relocate",
    "soil.crop": "Crop you plan to grow",
    "soil.crop.placeholder": "e.g., Cotton, Wheat, Tomato",
    "soil.generate": "Generate soil report",
    "soil.generating": "Reading satellite + soil data…",
    "soil.done": "Report ready",
    "soil.failed": "Could not generate report. Try again.",
    "soil.needLocation": "Please share your GPS location first",
    "soil.geo.unsupported": "Your phone does not support GPS",
    "soil.geo.denied": "Location permission denied. Allow it from your phone settings.",
    "soil.geo.failed": "Could not get GPS location. Try moving outside.",
    "soil.regional.title": "Regional estimate",
    "soil.partial.title": "Partial satellite data",
    "soil.regional.body": "Satellite soil data was incomplete for this exact spot. Advice is based on regional averages — get a local soil test for precision.",
    "soil.summary": "Verdict",
    "soil.ph": "Soil pH",
    "soil.ph.acidic": "Acidic — add lime",
    "soil.ph.alkaline": "Alkaline — add gypsum",
    "soil.ph.neutral": "Healthy",
    "soil.texture": "Texture",
    "soil.oc": "Organic carbon",
    "soil.nitrogen": "Total nitrogen",
    "soil.composition": "Soil composition",
    "soil.sand": "Sand",
    "soil.silt": "Silt",
    "soil.clay": "Clay",
    "soil.moisture.title": "Soil moisture (now)",
    "soil.moisture.surface": "Surface (0–3 cm)",
    "soil.moisture.deep": "Root zone (9–27 cm)",
    "soil.actions": "Top actions",
    "soil.fertilizer": "Fertilizer plan",
    "soil.irrigation": "Irrigation plan",

    "nav.download": "Get App",
    "download.tagline": "Hansa is now on your phone",
    "download.h1": "Download the Hansa app",
    "download.subtitle": "Diagnose crops, verify medicines and track your fields — even when offline. Available for Android, iPhone, and as a free PWA.",
    "download.playStore.label": "Android",
    "download.playStore.primary": "Get on Google Play",
    "download.playStore.sub": "Free · Hindi + English",
    "download.appStore.label": "iPhone",
    "download.appStore.primary": "Download on App Store",
    "download.appStore.sub": "Free · iOS 14+",
    "download.apk": "Download APK directly",
    "download.pwa.title": "No store? Install instantly",
    "download.pwa.subtitle": "Hansa works as a Progressive Web App — adds an icon to your home screen, no download needed.",
    "download.pwa.android.title": "Android (Chrome)",
    "download.pwa.android.s1": "Open thecropdoctor.com in Chrome",
    "download.pwa.android.s2": "Tap the {icon} menu (3 dots) at the top right",
    "download.pwa.android.s3": "Tap 'Install app' or 'Add to Home screen'",
    "download.pwa.ios.title": "iPhone (Safari)",
    "download.pwa.ios.s1": "Open thecropdoctor.com in Safari",
    "download.pwa.ios.s2": "Tap the {icon} Share button at the bottom",
    "download.pwa.ios.s3": "Scroll and tap 'Add to Home Screen'",
    "download.why.title": "Why install?",
    "download.why.fast": "Faster",
    "download.why.fastBody": "Loads instantly from your phone — no waiting for the browser.",
    "download.why.offline": "Works offline",
    "download.why.offlineBody": "Scan even with poor network — uploads sync automatically.",
    "download.why.notify": "Notifications",
    "download.why.notifyBody": "Get weather alerts and treatment reminders straight on your phone.",

    "installBanner.endorsement": "Sanket says",
    "installBanner.title": "Install the Hansa app",
    "installBanner.subtitle": "\"Faster scans for my fellow farmers — install in 1 tap.\"",
    "installBanner.install": "Install",

    "lang.en": "English",
    "lang.hi": "हिन्दी (Hindi)",
    "lang.mr": "मराठी (Marathi)",
    "lang.ta": "தமிழ் (Tamil)",
    "lang.te": "తెలుగు (Telugu)",
  },

  hi: {
    "common.login": "लॉगिन",
    "common.signup": "साइन अप",
    "common.logout": "लॉगआउट",
    "common.cancel": "रद्द करें",
    "common.delete": "हटाएं",
    "common.save": "सहेजें",
    "common.back": "वापस",
    "common.loading": "लोड हो रहा है…",
    "common.confirm": "पुष्टि करें",
    "common.required": "आवश्यक",
    "common.optional": "(वैकल्पिक)",

    "nav.home": "होम",
    "nav.history": "इतिहास",
    "nav.fields": "खेत",
    "nav.profile": "प्रोफ़ाइल",

    "landing.tagline": "12 सेकंड में AI द्वारा फसल रोग पहचान",
    "landing.h1.line1": "पत्ते की फोटो खींचें।",
    "landing.h1.line2": "अपनी फसल बचाएं।",
    "landing.subtitle": "अपनी फसल की फोटो अपलोड करें और तुरंत रोग पहचान, जैविक व रासायनिक उपचार सलाह — आपकी अपनी भाषा में पाएं।",
    "landing.cta.scan": "मेरी फसल स्कैन करें",
    "landing.cta.haveAccount": "मेरा पहले से खाता है",
    "landing.trusted": "किसानों का भरोसा",
    "landing.languages": "5 भाषाएँ",
    "landing.howH2": "हंसा कैसे मदद करता है",
    "landing.howSub": "खेत से सीधे आपके फोन तक — विशेषज्ञ सलाह, हमेशा तैयार।",
    "landing.feat.diag.title": "तुरंत निदान",
    "landing.feat.diag.body": "पत्ते की फोटो खींचें; AI रोग पहचान, लक्षण और कारण विश्वास स्तर के साथ बताता है।",
    "landing.feat.treat.title": "जैविक + रासायनिक",
    "landing.feat.treat.body": "प्राकृतिक उपाय और सिद्ध रासायनिक उपचार दोनों, स्पष्ट खुराक संकेत के साथ।",
    "landing.feat.weather.title": "मौसम-स्मार्ट टिप्स",
    "landing.feat.weather.body": "लाइव मौसम डेटा और अगले 3 दिनों के लिए AI द्वारा खेती सलाह।",
    "landing.feat.lang.title": "5 भाषाएँ",
    "landing.feat.lang.body": "English, हिन्दी, मराठी, தமிழ், తెలుగు — अपनी पसंदीदा भाषा चुनें।",
    "landing.feat.history.title": "स्कैन इतिहास",
    "landing.feat.history.body": "सभी स्कैन सहेजे जाते हैं ताकि आप समय के साथ फसल स्वास्थ्य देख सकें।",
    "landing.feat.models.title": "मल्टी-मॉडल AI",
    "landing.feat.models.body": "स्मार्ट ऑटो राउटर हर स्कैन के लिए Gemini 3 Flash, GPT-5.2 या Claude Sonnet 4.5 चुनता है।",
    "landing.feat.medCheck.title": "दवा / केमिकल जाँच",
    "landing.feat.medCheck.body": "किसी भी कीटनाशक की बोतल की फोटो लें — AI बताएगा यह आपकी फसल के लिए सही है या नहीं, सही मात्रा और सुरक्षा चेतावनी।",

    "landing.medCheck.tagline": "नया · हंसा की खासियत",
    "landing.medCheck.h2.line1": "गलत दवा पर",
    "landing.medCheck.h2.line2": "पैसा बर्बाद न करें",
    "landing.medCheck.body": "बस बोतल या लेबल की फोटो लें। हंसा सक्रिय तत्व पढ़कर बताएगा कि यह आपकी फसल के लिए सुरक्षित है या नहीं, प्रति लीटर सही मात्रा, छिड़काव का समय, सुरक्षा सामग्री और हानिकारक रसायन की चेतावनी — सब आपकी भाषा में।",
    "landing.medCheck.b1": "जाँचें कि केमिकल आपकी फसल और रोग के लिए सही है",
    "landing.medCheck.b2": "प्रति लीटर और प्रति एकड़ सटीक मात्रा पाएं",
    "landing.medCheck.b3": "सुरक्षा चेतावनी, PPE और दोबारा प्रवेश अंतराल",
    "landing.medCheck.b4": "उपलब्ध होने पर जैविक विकल्प सुझाता है",
    "landing.medCheck.cta": "दवा जाँच आज़माएं",
    "landing.medCheck.cardLabel": "दवा जाँच परिणाम",
    "landing.medCheck.cardSafe": "टमाटर · झुलसा रोग के लिए सुरक्षित",
    "landing.medCheck.cardWarn": "दस्ताने व मास्क पहनें। कटाई से पहले छिड़काव से बचें।",

    "auth.welcomeBack": "वापसी पर स्वागत है",
    "auth.welcomeBack.sub": "अपनी फसलें स्कैन और प्रबंधित करने के लिए लॉगिन करें।",
    "auth.startFree": "मुफ्त में शुरू करें",
    "auth.startFree.sub": "फसलों का निदान और ट्रैक करने के लिए खाता बनाएं।",
    "auth.email": "ईमेल",
    "auth.password": "पासवर्ड",
    "auth.fullName": "पूरा नाम",
    "auth.location": "स्थान",
    "auth.signingIn": "साइन इन हो रहा है…",
    "auth.creating": "बना रहे हैं…",
    "auth.create": "खाता बनाएं",
    "auth.newHere": "नए हैं?",
    "auth.haveAccount": "क्या आपका पहले से खाता है?",
    "auth.useMobile": "मोबाइल OTP से लॉगिन",
    "auth.useEmail": "ईमेल और पासवर्ड से लॉगिन",
    "auth.phone": "मोबाइल नंबर",
    "auth.phonePlaceholder": "+91 98XXXXXXXX",
    "auth.sendOtp": "OTP भेजें",
    "auth.sendingOtp": "भेज रहे हैं…",
    "auth.otp": "OTP कोड",
    "auth.otpPlaceholder": "6-अंकीय कोड",
    "auth.verifyOtp": "सत्यापित करें",
    "auth.verifying": "सत्यापित कर रहे हैं…",
    "auth.otpSent": "OTP भेज दिया गया है। SMS देखें।",
    "auth.changePhone": "नंबर बदलें",
    "auth.firstTimeName": "आपका नाम (पहली बार)",

    "dash.greet": "नमस्ते {name} 👋",
    "dash.subtitle": "चलिए आपकी फसल की जाँच करते हैं।",
    "dash.scanCrop": "अपनी फसल स्कैन करें",
    "dash.scanCrop.sub": "प्रभावित पत्ते या पौधे की स्पष्ट फोटो लें या अपलोड करें",
    "dash.useCamera": "कैमरा खोलें",
    "dash.uploadPhoto": "फोटो अपलोड करें",
    "dash.cropHint": "यह कौन सी फसल है?",
    "dash.cropHint.placeholder": "जैसे, टमाटर, गेहूँ, चावल...",
    "dash.aiModel": "AI मॉडल",
    "dash.language": "भाषा",
    "dash.field": "खेत / प्लॉट",
    "dash.field.none": "कोई खेत नहीं (एकल स्कैन)",
    "dash.diagnose": "अभी निदान करें",
    "dash.diagnosing": "निदान हो रहा है…",
    "dash.saveOffline": "ऑफ़लाइन सहेजें",
    "dash.weather": "आज का मौसम",
    "dash.weatherLoading": "मौसम लोड हो रहा है…",
    "dash.weatherUnavail": "मौसम उपलब्ध नहीं",
    "dash.recentScans": "हाल के स्कैन",
    "dash.viewAll": "सभी देखें",
    "dash.noScans": "अभी तक कोई स्कैन नहीं। पहला आज़माएं!",
    "dash.offlineBanner": "आप ऑफ़लाइन हैं। स्कैन कतार में सहेजे जाएंगे।",
    "dash.queuedPending": "{n} स्कैन कतार में",
    "dash.queuedPendingPlural": "{n} स्कैन कतार में",
    "dash.syncing": "{n} स्कैन सिंक हो रहा है…",
    "dash.syncingPlural": "{n} स्कैन सिंक हो रहे हैं…",
    "dash.syncNow": "अभी सिंक करें",
    "dash.listening": "सुन रहा हूँ… फसल का नाम बोलें",
    "dash.voiceCaptured": "आवाज़ कैप्चर हुई",
    "dash.uploadFirst": "कृपया पहले फसल की फोटो अपलोड करें",
    "dash.diagnosisReady": "निदान तैयार है",
    "dash.savedOffline": "ऑफ़लाइन सहेजा गया। ऑनलाइन होते ही अपलोड कर देंगे।",
    "dash.networkIssue": "नेटवर्क समस्या — ऑफ़लाइन सहेजा, फिर कोशिश करेंगे।",

    "scan.pdf": "PDF",
    "scan.askAi": "AI से पूछें",
    "scan.delete": "हटाएं",
    "scan.deleteTitle": "इस स्कैन को हटाएं?",
    "scan.deleteDesc": "यह क्रिया वापस नहीं की जा सकती। निदान और छवि स्थायी रूप से हटा दी जाएगी।",
    "scan.pdfExported": "PDF निर्यात हुआ",
    "scan.pdfFailed": "PDF निर्यात विफल",
    "scan.deleted": "स्कैन हटा दिया गया",
    "scan.deleteFailed": "हटाना विफल",
    "scan.notFound": "स्कैन नहीं मिला",
    "scan.deleting": "हटा रहे हैं…",

    "diag.notPlant": "कोई पौधा नहीं मिला",
    "diag.healthy": "स्वस्थ पौधा",
    "diag.unknown": "अज्ञात समस्या",
    "diag.crop": "फसल",
    "diag.confidence": "विश्वास स्तर",
    "diag.symptoms": "देखे गए लक्षण",
    "diag.causes": "संभावित कारण",
    "diag.organic": "जैविक उपाय",
    "diag.chemical": "रासायनिक उपचार",
    "diag.prevention": "रोकथाम के सुझाव",
    "diag.greatNews": "अच्छी खबर",
    "diag.greatNewsBody": "आपका पौधा स्वस्थ दिख रहा है। नियमित देखभाल और निगरानी जारी रखें।",
    "diag.prePlant.title": "बुवाई से पहले की गाइड",
    "diag.prePlant.season": "उत्तम मौसम",
    "diag.prePlant.soil": "मिट्टी की तैयारी",
    "diag.prePlant.spacing": "पौधों की दूरी",
    "diag.prePlant.fertilizer": "उर्वरक",
    "diag.prePlant.seed": "बीज चयन",
    "diag.prePlant.timeline": "फसल की समय-सारणी",
    "diag.prePlant.yield": "अनुमानित उपज",
    "diag.growth.title": "वृद्धि जाँच",
    "diag.growth.stage": "वृद्धि अवस्था",
    "diag.growth.advice": "इस अवस्था के लिए देखभाल सुझाव",
    "diag.buy": "खरीदें",

    "history.title": "स्कैन इतिहास",
    "history.sub": "आपके सभी पुराने फसल निदान।",
    "history.empty": "अभी तक कोई स्कैन नहीं",
    "history.emptySub": "अपना पहला स्कैन करके इतिहास बनाएं।",
    "history.scanNow": "अभी स्कैन करें",
    "history.confident": "{c}% विश्वास",

    "fields.title": "मेरे खेत",
    "fields.sub": "नामित खेत और समय के साथ वृद्धि ट्रैक करें।",
    "fields.empty": "अभी तक कोई खेत नहीं",
    "fields.emptySub": "एक खेत बनाएं ताकि फसल के पूरे जीवन-चक्र में स्कैन ट्रैक कर सकें।",
    "fields.new": "नया खेत",
    "fields.create": "खेत बनाएं",
    "fields.creating": "बना रहे हैं…",
    "fields.name": "खेत का नाम",
    "fields.name.placeholder": "जैसे, टमाटर प्लॉट A",
    "fields.crop": "फसल",
    "fields.crop.placeholder": "जैसे, टमाटर",
    "fields.plantedOn": "बोवाई की तिथि",
    "fields.scanCount": "{n} स्कैन",
    "fields.scanCountPlural": "{n} स्कैन",
    "fields.lastScan": "अंतिम स्कैन: {date}",
    "fields.openTimeline": "टाइमलाइन खोलें",
    "fields.timeline": "वृद्धि टाइमलाइन",
    "fields.noTimelineScans": "इस खेत के लिए अभी तक कोई स्कैन नहीं। डैशबोर्ड से इस खेत को चुनकर एक अपलोड करें।",
    "fields.deleteTitle": "इस खेत को हटाएं?",
    "fields.deleteDesc": "इस खेत से जुड़े स्कैन रहेंगे लेकिन अनलिंक हो जाएंगे। यह वापस नहीं किया जा सकता।",
    "fields.deleted": "खेत हटा दिया गया",

    "profile.title": "प्रोफ़ाइल",
    "profile.member": "हंसा सदस्य",
    "profile.joined": "जुड़े",

    "chat.title": "AI कृषि सलाहकार",

    "chem.title": "दवा / केमिकल जाँचें",
    "chem.subtitle": "बोतल या लेबल की फोटो लें — AI बताएगा कि यह आपकी फसल के लिए सही है या नहीं और कितनी मात्रा डालनी है।",
    "chem.linkedScan": "आपके हाल के स्कैन से जुड़ा",
    "chem.useCamera": "कैमरा खोलें",
    "chem.uploadPhoto": "फोटो अपलोड करें",
    "chem.crop": "फसल",
    "chem.crop.placeholder": "जैसे, टमाटर, गेहूँ",
    "chem.disease": "रोग / समस्या",
    "chem.disease.placeholder": "जैसे, झुलसा रोग, माहू",
    "chem.verify": "दवा जाँचें",
    "chem.verifying": "लेबल पढ़ रहे हैं…",
    "chem.uploadFirst": "कृपया पहले लेबल की फोटो जोड़ें",
    "chem.tooLarge": "फोटो बहुत बड़ी है। छोटी फोटो लें।",
    "chem.failed": "जाँच विफल। दोबारा कोशिश करें।",
    "chem.done": "जाँच पूरी",
    "chem.unreadable": "लेबल पढ़ा नहीं जा सका",
    "chem.verdict.safe": "उपयोग के लिए सुरक्षित",
    "chem.verdict.unsafe": "उपयोग न करें",
    "chem.verdict.unclear": "सावधानी से प्रयोग करें",
    "chem.dosage": "मात्रा",
    "chem.spray": "छिड़काव का समय",
    "chem.phi": "कटाई से पहले अंतराल",
    "chem.rei": "खेत में दोबारा प्रवेश",
    "chem.ppe": "सुरक्षा सामग्री (PPE)",
    "chem.warnings": "सुरक्षा चेतावनी",
    "chem.alternatives": "जैविक विकल्प",
    "dash.verifyMedicine": "दवा / केमिकल जाँचें",
    "dash.verifyMedicineSub": "बोतल या लेबल स्कैन करें — सुरक्षा और मात्रा सलाह पाएं",
    "dash.soilReport": "सैटेलाइट मिट्टी रिपोर्ट",
    "dash.soilReportSub": "मुफ्त pH, जैविक तत्व और खाद सलाह आपके खेत के लिए",
    "scan.verifyMedicine": "दवा जाँचें",

    "soil.title": "मिट्टी रिपोर्ट",
    "soil.subtitle": "आपके खेत के लिए मुफ्त सैटेलाइट मिट्टी डेटा, साथ में AI द्वारा खाद व सिंचाई सलाह।",
    "soil.location": "खेत का स्थान",
    "soil.location.none": "GPS साझा करने के लिए relocate पर टैप करें",
    "soil.relocate": "फिर खोजें",
    "soil.crop": "जो फसल लगाना चाहते हैं",
    "soil.crop.placeholder": "जैसे, कपास, गेहूँ, टमाटर",
    "soil.generate": "मिट्टी रिपोर्ट बनाएं",
    "soil.generating": "सैटेलाइट + मिट्टी डेटा पढ़ रहे हैं…",
    "soil.done": "रिपोर्ट तैयार",
    "soil.failed": "रिपोर्ट नहीं बनी। दोबारा कोशिश करें।",
    "soil.needLocation": "कृपया पहले GPS स्थान साझा करें",
    "soil.geo.unsupported": "आपका फ़ोन GPS समर्थन नहीं करता",
    "soil.geo.denied": "स्थान अनुमति अस्वीकृत। फ़ोन सेटिंग्स से अनुमति दें।",
    "soil.geo.failed": "GPS स्थान नहीं मिला। बाहर जाकर कोशिश करें।",
    "soil.regional.title": "क्षेत्रीय अनुमान",
    "soil.partial.title": "आंशिक सैटेलाइट डेटा",
    "soil.regional.body": "इस स्थान के लिए सैटेलाइट डेटा अधूरा था। सलाह क्षेत्रीय औसत पर आधारित है — सटीक जानकारी के लिए स्थानीय मिट्टी परीक्षण कराएं।",
    "soil.summary": "निष्कर्ष",
    "soil.ph": "मिट्टी pH",
    "soil.ph.acidic": "अम्लीय — चूना डालें",
    "soil.ph.alkaline": "क्षारीय — जिप्सम डालें",
    "soil.ph.neutral": "स्वस्थ",
    "soil.texture": "बनावट",
    "soil.oc": "जैविक कार्बन",
    "soil.nitrogen": "कुल नाइट्रोजन",
    "soil.composition": "मिट्टी संरचना",
    "soil.sand": "रेत",
    "soil.silt": "गाद",
    "soil.clay": "चिकनी",
    "soil.moisture.title": "मिट्टी की नमी (अभी)",
    "soil.moisture.surface": "ऊपरी सतह (0–3 सेमी)",
    "soil.moisture.deep": "जड़ क्षेत्र (9–27 सेमी)",
    "soil.actions": "मुख्य कार्य",
    "soil.fertilizer": "खाद योजना",
    "soil.irrigation": "सिंचाई योजना",

    "nav.download": "ऐप डाउनलोड",
    "download.tagline": "हंसा अब आपके फ़ोन पर",
    "download.h1": "हंसा ऐप डाउनलोड करें",
    "download.subtitle": "फसल का निदान, दवा की जाँच और खेत ट्रैकिंग — ऑफलाइन भी। Android, iPhone और मुफ्त PWA पर उपलब्ध।",
    "download.playStore.label": "Android",
    "download.playStore.primary": "Google Play से डाउनलोड",
    "download.playStore.sub": "मुफ्त · हिन्दी + English",
    "download.appStore.label": "iPhone",
    "download.appStore.primary": "App Store से डाउनलोड",
    "download.appStore.sub": "मुफ्त · iOS 14+",
    "download.apk": "APK सीधे डाउनलोड करें",
    "download.pwa.title": "स्टोर नहीं? तुरंत इंस्टॉल करें",
    "download.pwa.subtitle": "हंसा एक PWA है — होम स्क्रीन पर आइकन जुड़ जाता है, कोई डाउनलोड नहीं चाहिए।",
    "download.pwa.android.title": "Android (Chrome)",
    "download.pwa.android.s1": "Chrome में thecropdoctor.com खोलें",
    "download.pwa.android.s2": "ऊपर दाईं ओर {icon} मेनू (3 बिंदु) पर टैप करें",
    "download.pwa.android.s3": "'ऐप इंस्टॉल करें' या 'होम स्क्रीन पर जोड़ें' टैप करें",
    "download.pwa.ios.title": "iPhone (Safari)",
    "download.pwa.ios.s1": "Safari में thecropdoctor.com खोलें",
    "download.pwa.ios.s2": "नीचे {icon} शेयर बटन पर टैप करें",
    "download.pwa.ios.s3": "स्क्रॉल करके 'Add to Home Screen' टैप करें",
    "download.why.title": "इंस्टॉल क्यों करें?",
    "download.why.fast": "तेज़",
    "download.why.fastBody": "ब्राउज़र की प्रतीक्षा बिना — सीधे फ़ोन से तुरंत खुलता है।",
    "download.why.offline": "ऑफ़लाइन काम",
    "download.why.offlineBody": "खराब नेटवर्क में भी स्कैन — ऑनलाइन होने पर अपने आप अपलोड।",
    "download.why.notify": "सूचनाएं",
    "download.why.notifyBody": "मौसम अलर्ट और उपचार रिमाइंडर सीधे आपके फ़ोन पर।",

    "installBanner.endorsement": "Sanket कहते हैं",
    "installBanner.title": "हंसा ऐप इंस्टॉल करें",
    "installBanner.subtitle": "\"मेरे किसान भाइयों के लिए तेज़ स्कैन — 1 टैप में इंस्टॉल करें।\"",
    "installBanner.install": "इंस्टॉल",

    "lang.en": "English",
    "lang.hi": "हिन्दी",
    "lang.mr": "मराठी",
    "lang.ta": "தமிழ்",
    "lang.te": "తెలుగు",
  },
};

// Languages besides en/hi share the en strings as fallback (UI not localised yet — AI responses still localised)
TRANSLATIONS.mr = { ...TRANSLATIONS.en };
TRANSLATIONS.ta = { ...TRANSLATIONS.en };
TRANSLATIONS.te = { ...TRANSLATIONS.en };

export const SUPPORTED_LANGUAGES = ["en", "hi", "mr", "ta", "te"];
